import {
  GET_CUSTOMER_LISTS,
  GET_CUSTOMER_LIST,
  SET_CUSTOMER_LIST
} from '../Actions/customerListActions'

const initialState = {
  customerList: {},
  customerLists: []
}

const customerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LISTS:
      return {
        ...state,
        customerLists: action.customerLists
      }
    case GET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: action.customerList
      }
    case SET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: action.customerList
      }
    default:
      return state
  }
}

export default customerListReducer
